import { BasePrice } from './base-price';
import { PriceLookupKey } from './types';

export class NormalPrice extends BasePrice {
    constructor(price: number, currency: string, lookupKey?: PriceLookupKey) {
        super(price, currency, lookupKey);
    }
}
